import { Configuration, OrdersApi } from "../../generated-client";
import "reflect-metadata";

function toLocalDateString(date: Date): string {
	return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

function normalizeSerializedDate(value: unknown): unknown {
	if (typeof value !== "string" || !value.includes("T")) {
		return value;
	}

	const parsedDate = new Date(value);
	if (Number.isNaN(parsedDate.getTime())) {
		return value;
	}

	return toLocalDateString(parsedDate);
}

export class OrdersClient {
	public ordersApi: OrdersApi;

	constructor() {
		const basePath =
			window.BACKEND_URL || location.origin || "http://localhost:3000";
		const config = new Configuration({
			basePath: basePath,
			accessToken: () => sessionStorage.getItem("jwt") || "",
			middleware: [
				{
					pre: async ({ url, init }) => {
						if (
							typeof init.body !== "string" ||
							(!url.includes("/api/v1/orders/create") &&
								!/\/api\/v1\/orders\/[^/?]+(?:\?.*)?$/.test(url))
						) {
							return;
						}

						const payload = JSON.parse(init.body) as Record<string, unknown>;

						return {
							url,
							init: {
								...init,
								body: JSON.stringify({
									...payload,
									docDate: normalizeSerializedDate(payload.docDate),
									docDueDate: normalizeSerializedDate(payload.docDueDate),
								}),
							},
						};
					},
				},
			],
		});
		this.ordersApi = new OrdersApi(config);
	}
}
